export default __webpack_public_path__ + "static/media/Privacy_CommonMenu.39dd36d5.svg";